/* One optional attribute; no product mutation, note write or global interception. */
(() => {
  if (customElements.get('shiftwave-cart-attribution')) return;
  const key = 'How did you hear about Shiftwave?';
  const instances = new Set();
  const state = { initialized: false, value: '', revision: 0, dirty: false, pending: null, error: false };
  const notify = () => instances.forEach(instance => instance.sync());

  function save() {
    if (state.pending) return state.pending;
    state.error = false;
    state.pending = (async () => {
      while (state.dirty) {
        const revision = state.revision;
        const value = state.value;
        const response = await fetch(window.theme.routes.cart_update_url, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { [key]: value } }),
          signal: AbortSignal.timeout(10000)
        });
        if (!response.ok) throw new Error('Save failed');
        const cart = await response.json();
        if ((cart.attributes?.[key] || '') !== value) throw new Error('Save not confirmed');
        if (revision === state.revision) state.dirty = false;
      }
    })().catch(() => { state.error = true; }).finally(() => {
      state.pending = null;
      notify();
    });
    notify();
    return state.pending;
  }

  customElements.define('shiftwave-cart-attribution', class extends HTMLElement {
    connectedCallback() {
      if (!state.initialized) {
        state.value = this.dataset.savedAnswer || '';
        state.initialized = true;
      }
      instances.add(this);
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.querySelector('[data-attribution-choice]').addEventListener('change', event => {
        event.stopPropagation();
        state.value = event.target.value;
        state.revision++;
        state.dirty = true;
        save();
      }, options);
      this.querySelector('[data-attribution-retry]').addEventListener('click', () => save(), options);
      this.form = document.getElementById(this.dataset.formId);
      if (this.form) this.form.addEventListener('submit', event => this.beforeCheckout(event), { ...options, capture: true });
      this.unsubscribe = window.theme.pubsub.subscribe(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, event => {
        if (!state.pending && !state.dirty && event.cart?.attributes) {
          state.value = event.cart.attributes[key] || '';
          notify();
        }
      });
      this.sync();
    }

    disconnectedCallback() {
      instances.delete(this);
      this.controller?.abort();
      this.unsubscribe?.();
    }

    sync() {
      this.querySelector('[data-attribution-choice]').value = state.value;
      this.querySelector('[data-attribution-status]').textContent = state.pending ? 'Saving answer…'
        : state.error ? 'Answer could not be saved. Retry, or continue using Checkout.' : '';
      this.querySelector('[data-attribution-retry]').hidden = !state.error || !!state.pending;
    }

    async beforeCheckout(event) {
      const submitter = event.submitter || Array.from(document.querySelectorAll('button[name="checkout"]')).find(button => button.form === this.form);
      if (submitter?.name !== 'checkout' || !state.pending) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.waiting) return;
      this.waiting = true;
      try {
        while (state.pending) await state.pending;
        // Retry the same native button, so app click/submit checks run again.
        if (submitter.isConnected && !submitter.disabled) submitter.click();
      } finally {
        this.waiting = false;
      }
    }
  });
})();
